import React, { useEffect } from 'react';
import { Redirect, Route, Switch, RouteProps } from 'react-router-dom';
import { Layout } from 'antd';
import { ScrollToTop } from '@partsbadger/library';
import UserStore from '../../stores/UserStore';
import FourOhFour from '../../pages/404';
import { observer } from 'mobx-react';
import { configure } from 'mobx';
import BuildPart from 'pages/QuickTurn/PartDesigner';
import Cart from 'pages/QuickTurn/Cart';
import Checkout from 'pages/QuickTurn/Checkout';
import OrderHistory from 'pages/QuickTurn/OrderHistory';
import OrderDetails from 'pages/QuickTurn/OrderDetails';
import CheckoutSuccess from 'pages/QuickTurn/CheckoutSuccess';
import QuickTurnPartStore from 'stores/QuickTurnPartStore';
import QuickTurnBoltStore from 'stores/QuickTurnBoltStore';
import LandingPage from 'pages/QuickTurn/LandingPage';
import Footer from 'components/Footer';
import BoltDesigner from 'pages/QuickTurn/BoltDesigner';
import RedirectPreservingUTMQuery from '../../common/RedirectPreservingUTMQuery';
import PortalHeader from '@/layouts/sections/PortalHeader';

configure({ enforceActions: 'observed' });

const { Content, Header } = Layout;

interface Props {
    children: Element;
}

const PrivateRoute = observer(({ component: ChildComponent, ...restProps }: RouteProps) => {
    return (
        <Route
            {...restProps}
            render={props => {
                if (!UserStore.isAuthenticated) {
                    const next = window.location.pathname;
                    const searchParams = new URLSearchParams(location.search);
                    searchParams.set('next', next);
                    return <Redirect to={`/login?${searchParams.toString()}`} />;
                } else {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-ignore
                    return <ChildComponent {...props} />;
                }
            }}
        />
    );
});

const QuickTurnRouter = (props: Props) => {
    useEffect(() => {
        QuickTurnPartStore.init();
        QuickTurnBoltStore.init();

        if (UserStore.isAuthenticated) {
            if (QuickTurnPartStore.orderToken) {
                QuickTurnPartStore.getSalesOrderById(QuickTurnPartStore.orderToken);
            } else {
                QuickTurnPartStore.getCart();
            }
        }

        window.scrollTo(0, 0);
    }, []);

    return (
        <React.Fragment>
            <ScrollToTop />
            <Layout className="pb-customer-portal">
                <Layout>
                    <PortalHeader />
                    <Content>
                        {props.children}
                        <Switch>
                            <Route exact path="/quick-turn" component={LandingPage} />
                            <Route exact path="/quick-turn/design" component={BuildPart} />
                            <Route exact path="/quick-turn/design/bolt" component={BoltDesigner} />
                            <Route exact path="/quick-turn/cart" component={Cart} />
                            <Route exact path="/quick-turn/cart/checkout" component={Checkout} />
                            <PrivateRoute exact path="/quick-turn/cart/checkout/success" component={CheckoutSuccess} />
                            <PrivateRoute exact path="/quick-turn/order-history" component={OrderHistory} />
                            <PrivateRoute exact path="/quick-turn/order-history/:id" component={OrderDetails} />

                            {!props.children && <Route component={FourOhFour} />}
                        </Switch>
                    </Content>
                </Layout>
            </Layout>
            <Footer />
        </React.Fragment>
    );
};

export default observer(QuickTurnRouter);
